import React, { Fragment, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch, connect } from 'react-redux';
import { map } from 'lodash';
import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import Moment from 'react-moment';
import 'react-widgets/dist/css/react-widgets.css';
import * as constants from '../../../constants/constants';
import {
  getSuspiciousSameIPPlayers,
  setCheckingStatus,
  //getSuspiciousSameIPData,
} from '../../../actions/admin';
import PaginationOld from '../Menu/PaginationOld';
import classNames from 'classnames';
import { Popover, PopoverBody } from 'reactstrap';

const SuspiciousSameIPPlayers = ({ openModalSameIp, offset, setCheckingStatusFunc }) => {
  const { t } = useTranslation('admin');
  const dispatch = useDispatch();

  const [players, setPlayers] = useState([]);

  const allSuspiciousSameIPPlayers = useSelector(state => state.admin.suspiciousSameIPPlayers || []);
  useEffect(() => {
    setPlayers(allSuspiciousSameIPPlayers);
  }, [allSuspiciousSameIPPlayers]);

  const [checkingStatusPopoverOpen, setCheckingStatusPopoverOpen] = useState(null);

  const [currentPage, setCurrentPage] = useState(0);
  const pageSize = 50;

  useEffect(() => {
    dispatch(getSuspiciousSameIPPlayers());
  }, []);

  const checkingStatusPopoverRef = useRef(null);

  useEffect(() => {
    checkingStatusPopoverRef.current = checkingStatusPopoverOpen;
  }, [checkingStatusPopoverOpen]);

  useEffect(() => {
    const handleDocumentClick = (event) => {
      const currentOpen = checkingStatusPopoverRef.current;

      if (currentOpen) {
        if (
          (!event.target.id || !event.target.id.includes('checking-status-button-')) && !(event.target.className?.includes('checking-status-popover-body'))
        ) {
          const justClosedButton = document.getElementById(`checking-status-button-${currentOpen}`);
          if (justClosedButton) justClosedButton.focus();
          setCheckingStatusPopoverOpen(null);
        }
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handlePagination = (e, index) => {
    e.preventDefault();
    setCurrentPage(index);
  };

  const pagesCount = Math.ceil(players.length / pageSize);


  const toggleCheckingStatusPopover = (key) => {
    if (!checkingStatusPopoverOpen || checkingStatusPopoverOpen !== key) {
      setCheckingStatusPopoverOpen(key);
    } else {
      setCheckingStatusPopoverOpen(null);
    }
  }

  const getCheckingStatusButtonColor = (checkingStatus) => {
    if (checkingStatus === 'whitelisted') return 'light';
    if (checkingStatus === 'suspicious') return 'warning';
    if (checkingStatus === 'cheaters') return 'danger';
    return 'primary';
  }

  const setCheckingStatusWrapper = (pairKey, status, pairNames) => {
    setCheckingStatusFunc(pairKey, status, pairNames);


    const newPlayers = players.map(obj =>
      `${obj.player1}--${obj.player2}` === pairKey ? { ...obj, checkingStatus: status } : obj
    );

    setPlayers(newPlayers);
  }

  return (
    <Fragment>
      <table style={{ width: '100%', fontSize: 12, color: '#fff' }}>
        <colgroup>
          <col span="1" className="" />
        </colgroup>
        <thead>
          <tr>
            <th style={{ textAlign: 'center' }}>
              Date
            </th>
            <th style={{ textAlign: 'center' }}>
              Player 1
            </th>
            <th style={{ textAlign: 'center' }}>
              Player 2
            </th>
            <th style={{ textAlign: 'center' }}>
              Count
            </th>
            <th style={{ textAlign: 'center' }}>
              Giveaway
            </th>
            <th style={{ textAlign: 'center' }}>
              View
            </th>
            <th style={{ textAlign: 'center' }}>
              Checking status
            </th>
          </tr>
        </thead>
        <tbody>
          {players.slice(currentPage * pageSize, (currentPage + 1) * pageSize).map((player, index) => (
            (player.dateAdded && player.player1 && player.player2 && player.count) ? (
              <Fragment key={player.key}>
                <tr key={player.key} className={classNames({ 'allUsers-table-row odd': (index % 2 === 0), 'allUsers-table-row even ': index % 2 !== 0 })}>
                  <td className="allUsers-table-col">
                    {player.dateAdded && (
                      <Moment format="DD-MM-YYYY, HH:mm:ss" locale="lv">
                        {player.dateAdded + offset}
                      </Moment>
                    )}
                  </td>
                  <td className="allUsers-table-col">
                    {`${player.player1Name} ${player.player1IsBot ? ('(B)') : ('')}`}
                  </td>
                  <td className="allUsers-table-col">
                    {`${player.player2Name} ${player.player2IsBot ? ('(B)') : ('')}`}
                  </td>
                  <td className="allUsers-table-col">
                    {player.count}
                  </td>
                  <td className="allUsers-table-col">
                    {player.suspiciousPlays}
                  </td>
                  <td className="allUsers-table-col">
                    <Button onClick={() => openModalSameIp(player.player1, player.player2)}>
                      View
                    </Button>
                  </td>

                  <td className="allUsers-table-col">
                    <Button
                      id={`checking-status-button-${player.player1}--${player.player2}`}
                      onClick={() => toggleCheckingStatusPopover(`${player.player1}--${player.player2}`)}
                      color={getCheckingStatusButtonColor(player.checkingStatus)}
                    >
                      {player.checkingStatus || 'unchecked'}
                    </Button>
                    <Popover isOpen={checkingStatusPopoverOpen === `${player.player1}--${player.player2}`} popperClassName={`popover`} placement="top" target={`checking-status-button-${player.player1}--${player.player2}`}>
                      <PopoverBody className="popover-body info-popover-body text-center d-flex flex-column" style={{ gap: 5 }}>
                        <Button
                          color="primary"
                          onClick={() => setCheckingStatusWrapper(`${player.player1}--${player.player2}`, null, `${player.player1Name}--${player.player2Name}`)}
                          style={!player.checkingStatus ? { opacity: 0.3, pointerEvents: 'none' } : {}}
                        >
                          Unchecked
                        </Button>
                        <Button
                          color="light"
                          onClick={() => setCheckingStatusWrapper(`${player.player1}--${player.player2}`, 'whitelisted', `${player.player1Name}--${player.player2Name}`)}
                          style={player.checkingStatus === 'whitelisted' ? { opacity: 0.3, pointerEvents: 'none' } : {}}
                        >
                          Whitelisted
                        </Button>
                        <Button
                          color="warning"
                          onClick={() => setCheckingStatusWrapper(`${player.player1}--${player.player2}`, 'suspicious', `${player.player1Name}--${player.player2Name}`)}
                          style={player.checkingStatus === 'suspicious' ? { opacity: 0.3, pointerEvents: 'none' } : {}}
                        >
                          Suspicious
                        </Button>
                        <Button
                          color="danger"
                          onClick={() => setCheckingStatusWrapper(`${player.player1}--${player.player2}`, 'cheaters', `${player.player1Name}--${player.player2Name}`)}
                          style={player.checkingStatus === 'cheaters' ? { opacity: 0.3, pointerEvents: 'none' } : {}}
                        >
                          Cheaters
                        </Button>
                      </PopoverBody>
                    </Popover>
                  </td>
                </tr>
              </Fragment>
            ) : (null)
          ))}
        </tbody>
      </table>

      <PaginationOld
        show
        currentPage={currentPage}
        pagesCount={pagesCount}
        handlePagination={handlePagination}
      />


    </Fragment>
  );
};

SuspiciousSameIPPlayers.propTypes = {
  member: PropTypes.shape({
    email: PropTypes.string,
  }),
  allSuspiciousSameIPPlayers: PropTypes.shape({}),
};

SuspiciousSameIPPlayers.defaultProps = {
  member: {},
  allSuspiciousSameIPPlayers: [],
};

const mapStateToProps = state => ({

});

const mapDispatchToProps = {
  setCheckingStatusFunc: setCheckingStatus,

};

export default connect(mapStateToProps, mapDispatchToProps)(SuspiciousSameIPPlayers);
